export const profile = {
  Edit_your_profile: "Edit your profile",
  Logout: "Logout",
  Profile: "Profile",
  language: "Language",
} as const;
